@if (asset(); as asset) {
  <div class="asset-page-footer" (wheel)="stopPropagation($event)">
    @if (allowVersionHistory() && (asset.versions_total_count > 1 || galleryPermissions().can_edit)) {
      <app-context-menu [options]="{ width: '440px', noSpacing: true }" #menu>
        <button
          appButton
          name="version-menu"
          location="asset-page-footer"
          [hasIcon]="true"
          [color]="'dark-blur'"
          shape="round"
          iconTextSpacing="0"
          appTooltip="Versions"
          height="1"
          size="1"
          weight="bold"
          contextButton
          data-test-id="version-selector"
        >
          <app-svg [src]="'/assets/icons/stack.svg'"></app-svg>

          <span>{{ asset.version_data.version_name || 'v1' | uppercase }}</span>
          <app-svg src="/assets/icons/18/chevron-down.svg" size="-0-5"></app-svg>
        </button>
        <div contextContent>
          @if (menu.isOpen()) {
            <app-asset-version-menu
              contextContent
              [asset]="asset"
              [gallery]="gallery()"
              [galleryPermissions]="galleryPermissions()"
              [showFooter]="true"
              (onClose)="menu.close()"
            ></app-asset-version-menu>
          }
        </div>
      </app-context-menu>
    }

    <!-- Favorite -->
    @if (display().includes('favourite')) {
      <app-favorite-button [asset]="asset" [disabled]="!galleryPermissions().can_edit || clientMode">
        <button
          appButton
          name="toggle-like"
          location="asset-page-footer"
          color="dark-blur"
          shape="round"
          iconTextSpacing="0"
          height="1"
          size="1"
          weight="bold"
          appTooltip
          [appTooltip]="!galleryPermissions().can_edit || clientMode ? 'Favorite' : undefined"
          tooltipKeyboardShortcut="F"
          data-test-id="favorite"
          class="favorited-button"
          [class.favorited]="asset['is_liked']"
          [hasIcon]="true"
          (click)="toggleLike()"
          [iconButton]="asset.likes === 0"
        >
          @if (!asset['is_liked']) {
            <app-svg src="/assets/icons/heart-empty.svg"></app-svg>
          }
          @if (asset['is_liked']) {
            <app-svg src="/assets/icons/heart-filled.svg"></app-svg>
          }
          @if (asset.likes > 0) {
            <span><app-smooth-counter [value]="asset.likes"></app-smooth-counter></span>
          }
        </button>
      </app-favorite-button>
    }
    <!-- Status -->
    @if (display().includes('status') || display()['display-status']) {
      <app-asset-status-button
        [gallery]="gallery()"
        [asset]="asset"
        [approvedAssetCount]="gallery().approval_limits && approvedAssetCount$ | async"
        [defaultColor]="'dark-blur'"
        [displayOnly]="!!display()['display-status']"
        location="asset-page-footer"
        (onSelectStatus)="updateAssetStatus($event)"
        data-test-id="asset-status"
      ></app-asset-status-button>
    }
    <!-- Color label -->
    @if (display().includes('color_label')) {
      <app-context-menu [options]="{ width: '240px', noSpacing: true }" #menu>
        <button
          appButton
          name="color-labels-dropdown"
          location="asset-page-footer"
          [hasIcon]="true"
          [color]="currentLabel?.color || 'dark-blur'"
          shape="round"
          iconTextSpacing="0"
          [appTooltip]="'add-label-tooltip' | translate"
          height="1"
          size="1"
          weight="bold"
          contextButton
          data-test-id="color_label"
          class="color-label-button"
        >
          <app-svg [src]="'/assets/icons/color-label-filled.svg'"></app-svg>

          @if (!currentLabel) {
            <span>{{ 'add-label-button' | translate }}</span>
          }
          @if (currentLabel) {
            <span>{{ currentLabel.name | translateLabel }}</span>
          }
          <app-svg src="/assets/icons/18/chevron-down.svg" size="-0-5"></app-svg>
        </button>
        <div contextContent>
          <div class="button-menu">
            <app-color-label-context
              [currentColorLabel]="asset.color_label"
              [colorLabels]="colorLabels"
              location="asset-page-footer"
              (updateColorLabel)="updateColorLabel($event); menu.close()"
            ></app-color-label-context>
          </div>
        </div>
      </app-context-menu>
    }
    <!-- Comments -->
    @if (display().includes('comment')) {
      <button
        appButton
        name="toggle-comments"
        location="asset-page-footer"
        (click)="toggleCommentPlacementMode.emit()"
        [appTooltip]="'comments' | translate"
        tooltipKeyboardShortcut="C"
        [hasIcon]="true"
        data-test-id="comments-button"
        height="1"
        [color]="commentPlacementMode ? 'white' : 'dark-blur'"
        shape="round"
        iconTextSpacing="0"
        size="1"
        weight="bold"
      >
        <app-svg src="/assets/icons/comment-bubble.svg"></app-svg>
        <span class="count-flex">
          <span>{{ 'comment' | translate }}</span>
        </span>
        @if (commentPlacementMode) {
          <app-svg src="/assets/icons/16/cross.svg" size="-0-5"></app-svg>
        }
      </button>
    }
    <!-- Annotations -->
    @if (display().includes('annotation') && asset.type !== 'non_preview') {
      <button
        appButton
        name="annotation"
        location="asset-page-footer"
        (click)="onStartAnnotation.emit()"
        appTooltip="Draw Annotation"
        tooltipKeyboardShortcut="D"
        [hasIcon]="true"
        data-test-id="annotation-button"
        height="1"
        color="dark-blur"
        shape="round"
        iconTextSpacing="0"
        size="1"
        weight="bold"
      >
        <app-svg src="/assets/icons/annotation.svg"></app-svg>
        <span>Draw</span>
      </button>
    }
    @if (galleryPermissions().can_edit) {
      @if (allowedAndEnabledFeedbackOptions().length) {
        <button
          appButton
          name="review-settings"
          location="asset-page-footer"
          [iconButton]="true"
          color="dark-blur"
          shape="round"
          iconTextSpacing="0"
          height="1"
          (click)="openReviewSettings()"
          appTooltip="Review Options"
        >
          <app-svg src="/assets/icons/mixer-2.svg"></app-svg>
        </button>
      } @else {
        <button
          appButton
          name="review-settings"
          location="asset-page-footer"
          weight="bold"
          [hasIcon]="true"
          color="dark-blur"
          shape="round"
          iconTextSpacing="0"
          height="1"
          (click)="openReviewSettings()"
          appTooltip="Review Options"
        >
          <app-svg src="/assets/icons/mixer-2.svg"></app-svg>
          <span>Review: Off</span>
        </button>
      }
    }
  </div>
}
